import { useEffect } from 'react';

const MatchingGifts = () => {

  const scriptId = 'edl-script'

  useEffect(() => {

    // strip hash if it exists
    window.history.pushState("", document.title, window.location.pathname + window.location.search);

    // handles hard refresh
    // window.addEventListener("beforeunload", function(e) {
    //   sessionStorage.removeItem('removeScript');
    // });

    if (document.getElementById(scriptId) === null) {
      loadScript(scriptId)
    }

    // sessionStorage.setItem('removeScript', "true")

    // breaks on local because of the react strict-mode double render
    // the best answer I could come up with was the sessionStorage toggle
    // but that breaks it when not double-rendering, so it's commented out
    return () => {

      console.log('unmounting')
      // if (document.getElementById(scriptId) && sessionStorage.getItem('removeScript')) {
      if (document.getElementById(scriptId)) {
        console.log('removing script')
        // sessionStorage.removeItem('removeScript')
        document.getElementById(scriptId).remove()
      }
      else {
        console.log('script already removed')
        // sessionStorage.setItem('removeScript', "true")
      }
    }
  }, [])


  // NOTE: for now it looks like the only way to make this PCI compliant is to modify the dynamic script and load it locally.
  // According to KC at HEPData, UCLA may soon be transitioning Double the Donation which has a different version of the plugin that would meet PCI requirements.
  // So for for now, we load a local modified verion of the HEPData script instead, and hope it doesn't break
  const loadScript = (scriptId) => {
    const script = document.createElement("script");
    // script.src = "https://matchbox.hepdata.com/edl/ucla/rb8kfiw5/script.js";
    script.src = "/static/hepdata-modified-local-for-pci.js";
    script.nonce = window.globalNonce;
    script.async = false;
    script.id = scriptId;
    document.head.appendChild(script);
  };

  return  (
    <>
      <div id="edl-template"></div>
    </>
  )
}

export default MatchingGifts
